export enum ModalRegistry {
  addCharacterModal,
  editStoryModal,
  signupModal,
  storyDetailsModal,
  textInputModal,
  messageDetailsModal,
}
